module.exports = __webpack_public_path__ + "img/lb_terrein.9cab5c77.svg";